import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, switchMap} from 'rxjs';
import {environment} from 'src/environments/environment';
import {IDropdownNewEmployee} from '../interfaces/dropdown-new-employee.interface';
import {
  IEmployeeUniqueness,
  IGeneralRecruiter,
  ISalaryRecruiter,
} from '../interfaces/add-employee.interface';

/**
 * InterviewService is intended to interact with the server to get interviews, get dropdowns for adding an employee and add an employee
 */
@Injectable({
  providedIn: 'root',
})
export class AddEmployeeService {
  public isGeneralData = false; // shows whether the data is filled in the general tab
  public isSalaryData = false; // shows whether the data is filled in the salary tab
  public generalData = {} as IGeneralRecruiter;
  public salaryData = {} as ISalaryRecruiter;
  private url = environment.API + 'api/v1/Employee/general/new/'; // url for adding employee
  private ulrSalary = environment.API + 'api/v1/Salary/Create'; // url for adding salary

  constructor(private http: HttpClient) {}

  collectData(data: ISalaryRecruiter | IGeneralRecruiter, isSalary = false) {
    isSalary
      ? (this.salaryData = data as ISalaryRecruiter)
      : (this.generalData = data as IGeneralRecruiter);
  }

  isEmployeeUnique(employeeData: IEmployeeUniqueness): Observable<boolean> {
    return this.http.post<boolean>(
      `${environment.API}api/v1/Employee/unique`,
      employeeData
    );
  }

  checkEmployeeEmail(email: string): Observable<boolean> {
    return this.http.post<boolean>(
      `${environment.API}api/v1/Employee/isEmailAvailable/${email}`,
      null
    );
  }

  /**
   * This method sends new employee data to server
   * @returns request from server
   */
  addEmployee(): Observable<number> {
    if (this.generalData.subDepartment) {
      this.generalData.department = this.generalData.subDepartment;
    }
    const {hr} = this.generalData;
    if (hr && !hr.id) this.generalData.hr = null;
    delete this.generalData.subDepartment;
    const formData = new FormData();
    formData.append('employee', JSON.stringify(this.generalData));
    if (this.generalData['file'])
      formData.append('file', this.generalData['file']);
    if (this.salaryData['dataFile'])
      formData.append('dataFile', this.salaryData['dataFile']);

    return this.http.post<number>(`${this.url}`, formData).pipe(
      switchMap(id => {
        this.salaryData.employeeId = id;
        return this.http.post<number>(`${this.ulrSalary}`, this.salaryData);
      })
    );
  }

  /**
   * This method gets items for dropdowns from server
   * @returns request from server
   */
  getDropdowns(): Observable<IDropdownNewEmployee> {
    return this.http.get<IDropdownNewEmployee>(`${this.url}editMode`);
  }

  cleanVariables(): void {
    this.isGeneralData = false;
    this.isSalaryData = false;
    this.generalData = {} as IGeneralRecruiter;
    this.salaryData = {} as ISalaryRecruiter;
  }
}
